import { ActivityhubClientActivity } from '@clinic/client'

export const isTiDBOOMEvent = (event: ActivityhubClientActivity) => {
  const eventName = event.name?.toLowerCase()
  return eventName === 'oom' || eventName === 'tidb oom'
}

export const isTiKVOOMEvent = (event: ActivityhubClientActivity) => {
  const eventName = event.name?.toLowerCase()
  return eventName === 'tikv oom'
}

export const isOOMRiskEvent = (event: ActivityhubClientActivity) => {
  const eventName = event.name?.toLowerCase()
  return eventName === 'oom risk'
}

export const hasOOMInsight = (event: ActivityhubClientActivity) => {
  return isTiDBOOMEvent(event) || isOOMRiskEvent(event)
}
